"use strict";
export const UNKNOWN_SIM_ERROR = "Unknown gas simulation error";
export const WRAP_FALLBACK_GAS_LIMIT_IN_GWEI = 45e3;
export const FALLBACK_SWAP_REQUEST_POLL_INTERVAL_MS = 1e3;
